module.exports = __webpack_public_path__ + "static/media/sfl_1.c659f101.jpg";